import cn from 'classnames'
import styles from './Skeleton.module.scss'

export default function Skeleton () {
  return (
    <>
      <div
        className={cn(styles.skeleton, styles.shortHeight, styles.shortMargin)}
        style={{ marginTop: 16 }}
      />

      <div
        className={cn(
          styles.skeleton,
          styles.largeHeight,
          styles.standardMargin
        )}
      />

      <div className={styles.detail}>
        <div className={styles.leftPane}>
          <div
            className={cn(
              styles.skeleton,
              styles.standardHeight,
              styles.shortMargin
            )}
          />
          <div
            className={cn(
              styles.skeleton,
              styles.standardHeight,
              styles.standardMargin
            )}
          />
          <div
            className={cn(
              styles.skeleton,
              styles.largeHeight,
              styles.standardMargin
            )}
          />
          <div
            className={cn(
              styles.skeleton,
              styles.standardHeight,
              styles.standardMargin
            )}
          />
          <div
            className={cn(
              styles.skeleton,
              styles.largeHeight,
              styles.standardMargin
            )}
          />
          <div
            className={cn(
              styles.skeleton,
              styles.standardHeight,
              styles.standardMargin
            )}
          />
          <div
            className={cn(
              styles.skeleton,
              styles.standardHeight,
              styles.standardMargin
            )}
          />
          <div
            className={cn(
              styles.skeleton,
              styles.standardHeight,
              styles.standardMargin
            )}
          />
          <div
            className={cn(
              styles.skeleton,
              styles.standardHeight,
              styles.standardMargin
            )}
          />
          <div
            className={cn(
              styles.skeleton,
              styles.largeHeight,
              styles.standardMargin
            )}
          />
        </div>

        <div className={styles.rightPane}>
          <div
            className={cn(
              styles.skeleton,
              styles.buttonHeight,
              styles.shortMargin
            )}
          />
          <div className={cn(styles.skeleton, styles.buttonHeight)} />
        </div>
      </div>
    </>
  )
}
